import DefaultValidator from './default-validator';
import {PAGES} from '../definitions';

/**
 * Class to validate pages authorizations
 * This class can be replaces by AliasValidator but
 * $pages should not allows multi level resources definitions.
 *
 * // Correct
 * Auth.$pages['add-user']
 * // Incorrect
 * Auth.$pages.user.add
 * @extends DefaultValidator
 */
export default class PageValidator extends DefaultValidator {
    /**
     * Creates the proper validator based on instance state
     * @param {string} unknownProperty
     * @return {DefaultValidator}
     */
    $validate(unknownProperty) {
        const validator = PAGES[unknownProperty];
        if (validator instanceof Function) {
            // Most probably this validator was already instantiated by now
            // but add to cache so $validate wont be called again
            this.$cachedValidators[unknownProperty] = validator(unknownProperty, this);
            return this.$cachedValidators[unknownProperty];
        }
        // Page definition does not exist or is not a function.
        // This should not be the case, perhaps the developer forget to
        // included in the definition folder.
        // In this case it will be allowed only if the user $isAdmin
        // otherwise will be denied.
        return this.$addValidator(unknownProperty, DefaultValidator);
    }
}
